export default "__VITE_ASSET__SogcN1wS__"